import {
	MimaButton,
	Modal,
	MimaText,
	ReceiptCheckBox as RCB,
	MimaInput,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { downloadFormatDate, downloadXlsx2 } from '../../utils/download';
import successImg from '../../assets/img/Successful.png';
import React, { useState } from 'react';
import { Formik } from 'formik';

const UploadCommissionSheet = ({
	closeModal,
	uploaded,
	onSubmit,
	validationSchema,
	selectClick,
	printUpdateEmployeeSalaryData,
	loading,
	file,
}) => {

	const [employmentType, setEmploymentType] = useState('BOTH');
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitle" mb={3}>
				Commission
			</MimaText>
			<div className={styles.checks_group}>
				<MimaText ml={2} mb={2} variant="small">
					Employees Type
				</MimaText>

				<div className={styles.checks}>
					<RCB
						title="BOTH"
						name="employmentType"
						id="BOTH"
						onChange={() => {
							setEmploymentType('BOTH');
						}}
						checked={employmentType === 'BOTH'}
						value="BOTH"
					/>
					<RCB
						title="CONTRACT"
						name="employmentType"
						id="CONTRACT"
						onChange={() => {
							setEmploymentType('CONTRACT');
						}}
						checked={employmentType === 'CONTRACT'}
						value="CONTRACT"
					/>
					<RCB
						title="FULLTIME"
						id="FULLTIME"
						name="employmentType"
						onChange={() => {
							setEmploymentType('FULLTIME');
						}}
						checked={employmentType === 'FULLTIME'}
						value="FULLTIME"
					/>
				</div>
			</div>
			<MimaText
				variant="small"
				mb={2}
				width={38}
				align="center"
				color="var(--color-primary)">
				Download the excel document and input the Gross Pay. DO NOT EDIT THE ID
				FIELD
			</MimaText>
			<MimaButton
				title="Download Template"
				variant="outlined"
				width={38}
				onClick={() =>
					downloadXlsx2(
						employmentType !== 'BOTH'
							? printUpdateEmployeeSalaryData.filter(
									d => d.employmentType === employmentType
							  )
							: printUpdateEmployeeSalaryData,
						`Mima-Commission-Sheet-${downloadFormatDate(new Date())}`,
						employmentType
					)
				}
			/>

			{!uploaded && (
				<>
					<Formik
						initialValues={{
							tag: '',
							narration: '',
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<br />
								<MimaText variant="subtitle" mb={3}>
									Upload Commission Sheet
								</MimaText>
								<MimaButton
									title="Select file"
									variant="outlined"
									width={38}
									onClick={selectClick}
								/>
								<MimaText
									variant="small"
									mt={2}
									width={38}
									align="center"
									color="var(--color-primary)">
									{file?.name || ''}{' '}
								</MimaText>
								<MimaInput
									type="text"
									labelTitle="Tag"
									placeholder=""
									name="tag"
									value={values.tag}
									onChange={handleChange}
									onBlur={handleBlur}
									mt={2}
									error={errors.tag}
									touched={touched.tag}
								/>

								<MimaInput
									type="text"
									labelTitle="Narration"
									placeholder=""
									name="narration"
									value={values.narration}
									onChange={handleChange}
									onBlur={handleBlur}
									mt={2}
									error={errors.narration}
									touched={touched.narration}
								/>

								<MimaButton
									title="Upload"
									loading={loading}
									type="submit"
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{uploaded && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}>
						Upload <br />
						Successful
					</MimaText>
					{/* <MimaText width={38} align="center" color="var(--color-primary)">
						You successfully Terminated 25 employees
					</MimaText> */}
					<MimaButton title="Continue" onClick={closeModal} mt={3} />
				</>
			)}
		</Modal>
	);
};

export default UploadCommissionSheet;
